export enum MenuItems {
    Login,
    Roles,
    ImportCSV,
    Tenants,
    DataManagement,
    RankingTestHarness,
    CandidateSearchVectorTests,
    HelixSearch,
}
